import React from 'react';
import { Line } from 'react-konva';

interface SnapLinesProps {
  snapLines: {
    x?: number;
    y?: number;
  };
}

export const SnapLines: React.FC<SnapLinesProps> = ({ snapLines }) => {
  return (
    <>
      {snapLines.x !== undefined && (
        <Line
          x={snapLines.x}
          points={[0, -5000, 0, 5000]}
          stroke="#00ff00"
          strokeWidth={1}
          dash={[4, 4]}
        />
      )}
      {snapLines.y !== undefined && (
        <Line
          y={snapLines.y}
          points={[-5000, 0, 5000, 0]}
          stroke="#00ff00"
          strokeWidth={1}
          dash={[4, 4]}
        />
      )}
    </>
  );
};
